<template>
  <div
    data-testid="loading-horarios"
    :class="[
      'mb-main__loading-horarios flex items-center gap-4 text-xs text-right w-80 justify-end transition-opacity duration-200',
      isActive ? 'visible opacity-100' : 'invisible opacity-0',
    ]"
    aria-live="polite"
    aria-atomic="true"
  >
    <div class="flex items-center justify-end">
      <LucideTriangleAlert
        v-if="!loaded && !couldSync"
        :size="16"
        class="mr-4 size-16! shrink-0 grow-0 basis-16"
      />
      <span
        data-testid="loading-progress"
        class="leading-none block min-w-[38px]"
        >{{ clampedLoaded }}%</span
      >
      <LucideLoader2 :size="16" class="ml-4 h-16! w-16! animate-spin" />
    </div>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  loaded: number;
  couldSync?: boolean;
}>();

const clampedLoaded = computed(() => {
  const value = Number.parseInt(String(props.loaded), 10);
  if (Number.isNaN(value)) return 0;
  return Math.max(0, Math.min(100, value));
});

const isActive = computed(
  () => clampedLoaded.value > 0 && clampedLoaded.value < 100
);
</script>
